import { useConfig } from "./useConfig";
export function usePathCreator() {
  var config = useConfig();
  return function (path) {
    return "".concat(config.prefixPath).concat(path);
  };
}